import React, { useEffect } from 'react';
import { InputField } from '@repo/ui/components';
import { formatNumberInput, InputType, TIconProps } from 'types';

interface IFormRow {
  id: string;
  isEditable: boolean;
  isValid?: boolean;
  collapsedWarning?: boolean;
  label: string;
  maxLength?: number;
  placeholder?: string;
  type?: InputType;
  validationMessage?: string;

  startAdornment?: TIconProps | string;
  endAdornment?: TIconProps | string;
  value?: any;
  defaultValue?: any;
  valuePostfix?: string;

  decimals?: 0 | 2 | 1 | 3 | 4;
  onChange?(value): void;
  onSubmit?(value): void;
}

export const getDisplayValue = (props: IFormRow) => {
  return typeof props.value === 'number' || typeof props.defaultValue === 'number'
    ? props.value || props.defaultValue || '0'
    : props.value || props.defaultValue || '';
};

export const FormRow = (props: IFormRow) => {
  const [displayValue, setDisplayValue] = React.useState(getDisplayValue(props));

  useEffect(() => {
    setDisplayValue(getDisplayValue(props));
  }, [props.value, props.defaultValue]);

  return (
    <div className="">
      {props.isEditable ? (
        <InputField
          label={props.label}
          className="input-with-warning"
          isValid={props.isValid}
          defaultValue={props.defaultValue?.toString()}
          value={props.value?.toString()}
          id={props.id}
          maxLength={props.maxLength}
          onChange={props.onChange}
          onSubmit={props.onSubmit}
          errorMessage={props.validationMessage}
          placeholder={props.placeholder}
          type={props.type || InputType.TEXT_LINE}
          decimals={props.decimals}
        />
      ) : (
        <p className={'smallFont'}>
          {`${
            typeof displayValue === 'number'
              ? formatNumberInput(displayValue.toString(), props.type).formatted
              : displayValue
          }${props.valuePostfix}`}
        </p>
      )}
      <div />
    </div>
  );
};
